import toastr from 'toastr';
import { ajaxAddToBasket } from '../lib/addToBasket';

$('.js-buy-button').click(function (e) {
	e.preventDefault();
	const $button = $(this);
	const productId = parseInt($button.attr('data-product-id'));
	const productName = $button.attr('data-product-name')
		? `"${$button.attr('data-product-name')}"`
		: '';
	const msg = `${BX.message('1PDR_PRODUCT')} ${productName} ${BX.message('1PDR_ADDED')}
	<a href="${BX.message('SITE_DIR')}basket/">${BX.message('1PDR_TO_CART')}</a>.`;
	const basketLine = document.querySelector('.js-basket-line');

	if (productId <= 0) {
		return;
	}

	ajaxAddToBasket(productId, 1)
		.then((response) => {
			if (basketLine) {
				basketLine.outerHTML = response.data.basket_line_html;
			}
			toastr.success(msg);
			BX.onCustomEvent('LocalOnCartItemAdd', response.data);
		})
		.catch(function () {
			toastr.error(BX.message('1PDR_CART_ADD_ERROR'));
		});
});
